export default "__VITE_ASSET__CKgA2MOn__"